import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { FilterService } from 'src/app/services/filter.service';

@Injectable({
  providedIn: 'root'
})
export class AlertViewService {

  constructor(
    private apiService: ApiService,
    private filterService: FilterService
  ) {
  }
  
  postdata: any = {  
    "api_key": '100410'
  };
  

  alertsQuery(data: any) {
    
    let query = Object.assign({}, this.postdata, data);
    query['brand_key'] = this.filterService.baseQuery?.brand_key;

    if(sessionStorage.getItem("brandKeyForFilters")) {
      let brandKey: any = sessionStorage.getItem("brandKeyForFilters");
      let brand_key = JSON.parse(brandKey);
      query['brand_key'] = brand_key;
    }

    if(sessionStorage.getItem("tbl_name_suffix")) {
      let json:any = sessionStorage.getItem("tbl_name_suffix");
      json = JSON.parse(json);
      query['tbl_name_suffix'] = json.tbl_name_suffix;
    }
    
    if(!query['brand_key']) return new Observable((ob) => ob.next(undefined));
    return this.apiService.post("kpi/get-execution-details", query);
  }

}
